import { Row, Col, Typography, Image, Layout, Button } from 'antd'
import Img from './Img'
const { Text } = Typography

const InfoRectangle = ({ children, img }) => {
  return (
    <Layout className="info-rectangle">
      {img ? <Img className="top-image" src={img} /> : ''}
      {children}
    </Layout>
  )
}
export default InfoRectangle
